export default __webpack_public_path__ + "static/media/marker-sky.604d9282.png";